import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { TokenStorageService } from './token-storage.service';

/** Blocks navigation if no token. */
export const AuthGuard: CanActivateFn = () => {
  const tokens = inject(TokenStorageService);
  const router = inject(Router);

  if (!tokens.has()) {
    router.navigate(['/login']);
    return false;
  }
  return true;
};
